define('view/disclosure/action.items.component',['require','exports','module','underscore','blockit','backbone.radio','fukit'],function(require, exports, module) {
  // prettier-ignore
  var _       = require('underscore'),
      BlocKit = require('blockit'),
      Radio   = require('backbone.radio'),

      //behaviors
      ConfirmInvokeMethodOnEventBehavior = require('fukit').ConfirmInvokeMethodOnEventBehavior;

  module.exports = {
    collection: '@resources.workflowTaskModel.formDataModel.routingActionCollection',
    childViewOptions: {
      button: {
        bindings: {
          text: 'displayName',
        },

        behaviors: function() {
          var isResolveButton = this.getOption('model').get('routingId') === 'RESOLVE';
          var isSuppressModal = isResolveButton ||
                                this.getOption('model').get('routingId') === 'CONFIRM' ||
                                this.getOption('model').get('routingId') === 'DISCLOSEE' ||
                                this.getOption('model').get('routingId') === 'NO';
          var workflowTaskModel = Radio.request('AppKit.resourceService', 'resource', 'workflowTaskModel');
          var userPrincipalModel = Radio.request('AppKit.resourceService', 'resource', 'userPrincipalModel');

          function getDisclosureReviewer() {
            var disclosureAssignmentDetailModel = Radio.request(
              'AppKit.resourceService',
              'resource',
              'disclosureAssignmentDetailModel'
            );
            return disclosureAssignmentDetailModel.get('disclosureReviewer.id');
          }

          return {
            setRadioListener: {
              behaviorClass: Mn.Behavior.extend({
                onFirstBeforeRender: function() {
                  if (isResolveButton) {
                    this.listenTo(Radio.channel('resolveButton'), 'resolve:disclosure', function() {
                      this.view.trigger('confirm:complete:task');
                    });
                  }
                },
              }),
            },
            InvokeMethodOnEventBehavior: {
              events: {
                press: {
                  method: function() {


                    if (this.view.model.get('routingId') === 'RESOLVE') {
                      this.view.trigger('dislosure:resolve:decision');
                    } else if (this.view.model.get('routingId') === 'CONFIRM') {
                      this.view.trigger('dislosure:confirm:decision');
                    } else if (this.view.model.get('routingId') === 'DISCLOSEE'
                              || this.view.model.get('routingId') === 'NO') {
                      this.view.trigger('disclosure:return:decision');
                    }
                  },
                },
              },
              behaviorClass: BlocKit.InvokeMethodOnEventBehavior,
            },

            // Process the user's workflow action and route them accordingly
            // "press" is the default event and does not need to be defined.
            ConfirmInvokeMethodOnEventBehavior: {
              method: function(workflowTaskModel) {
                var actionModel = this.view.model;
                var taskDefinitionKey = workflowTaskModel.get('taskDefinitionKey');


                if (actionModel.get('actionDirection') === 'forward') {
                  switch (taskDefinitionKey) {
                    case 'assignReviewer':
                      this.view.trigger('confirm:complete:assignReviewer');
                      break;

                    case 'disclosureConfirmReview':
                      break;

                    case 'resolveDisclosure':
                      break;

                    default:
                      this.view.trigger('confirm:complete:task');
                      break;
                  }
                } else {
                  this.view.trigger('confirm:complete:task');
                }
              },
              suppressModal: isSuppressModal,
              args: [workflowTaskModel],
              modalOptions: {
                closable: true,
                header: {
                  text: 'Routing Confirmation',
                },
                content: {
                  text: 'Are you sure you want to route your disclosure?',
                },
                actions: {
                  confirmButton: {
                    text: 'Proceed',
                  },
                },
              },
              behaviorClass: ConfirmInvokeMethodOnEventBehavior,
            },



            ShowModalOnEventBehavior: {
              eventName: 'dislosure:resolve:decision',
              modalName: 'decisionConfirmationModal',
              behaviorClass: BlocKit.ShowModalOnEventBehavior,
            },

            HideActionsConditionally: {
              behaviorClass: Mn.Behavior.extend({
                onFirstBeforeRender: function() {
                  if (
                    this.view.model.get('routingId') === 'RESOLVE' &&
                    getDisclosureReviewer() !== userPrincipalModel.id
                  ) {
                    this.view.visible = false;
                  }
                },
              }),
            },

            ShowModalOnConfirmEventBehavior: {
              eventName: 'dislosure:confirm:decision',
              modalName: 'confirmReviewCompletionModal',
              behaviorClass: BlocKit.ShowModalOnEventBehavior,
            },

            ShowModalOnConfirmReturnEventBehavior: {
              eventName: 'disclosure:return:decision',
              modalName: 'confirmReturnToDiscloseeModal',
              behaviorClass: BlocKit.ShowModalOnEventBehavior,
            },

            FetchReviewerResourcesOnEventBehavior: {
              resources: ['@resources.availableReviewersCollection', '@resources.disclosureAssignmentDetailModel'],
              eventName: 'confirm:complete:assignReviewer',
              fetchModelIfNew: true,
              onAllSync: function() {
                this.view.trigger('confirm:complete:task');
              },

              behaviorClass: BlocKit.FetchResourcesOnEventBehavior,
            },
            FetchDecisionResourcesOnEventBehavior: {
              resources: ['@resources.sessionDecisionModel'],
              eventName: 'confirm:complete:resolveDisclosure',
              fetchModelIfNew: true,
              onAllSync: function() {
                this.view.trigger('confirm:complete:task');
              },

              behaviorClass: BlocKit.FetchResourcesOnEventBehavior,
            },

            //Listens for task completion event to be fired and determines the correct set of arguments
            //to pass to workflowTaskModel.completeTask()
            InvokeModelMethodOnEventBehavior: {
              eventName: 'confirm:complete:task',
              method: 'completeTask',
              targetModel: workflowTaskModel,
              methodArguments: function(workflowTaskModel) {
                var taskDefinitionKey = workflowTaskModel.get('taskDefinitionKey');

                var requiredTaskVariable = {
                  name: taskDefinitionKey,
                  value: this.view.model.get('routingId'),
                  type: 'string',
                };

                var optionalTaskVariables = [];

                // populate optional variables with routing action specific values
                switch (taskDefinitionKey) {
                  case 'assignReviewer':
                    optionalTaskVariables = getOptionalVariablesForReviewer();
                    break;

                  case 'disclosureConfirmReview':
                    optionalTaskVariables = getOptionalVariablesForResolve();

                    // Note: Don't send reviewer information for 'UNASSIGN'
                    // routing action, for if a user had assigned a new reviewer
                    // before unassigning AND before passing the disclosure to
                    // them, the optionalTaskVariable 'reviewerFullName' would
                    // override the current reviewer's name and make the audit
                    // history state that the quasi-assignee was unassigned,
                    // instead of the current reviewer

                    // Note: The routing action 'CONFIRM' doesn't reach this
                    // event, so it is not checked for in this case block
                    break;

                  case 'resolveDisclosure':
                    optionalTaskVariables =
                      requiredTaskVariable.value === 'REVIEWER'
                        ? getOptionalVariablesForReviewer()
                        : getOptionalVariablesForResolve();
                    break;
                }

                var variables = _.union([requiredTaskVariable], optionalTaskVariables);
                return [variables];

                /**
                 * Builds an array of variables that fulfill the 'optional' needs of resolution behavior
                 */
                function getOptionalVariablesForResolve() {
                  var sessionDecisionModel = Radio.request(
                    'AppKit.resourceService',
                    'resource',
                    'sessionDecisionModel'
                  );
                  return [
                    {
                      name: 'outcomeId',
                      value: sessionDecisionModel.get('outcome.id'),
                      type: 'string',
                    },
                    {
                      name: 'outcomeDisplayName',
                      value: sessionDecisionModel.get('outcome.displayName'),
                      type: 'string',
                    },
                  ];
                }

                /**
                 * Builds an array of variables that fulfill the 'optional' needs of passing-to-reviewer behavior
                 */
                function getOptionalVariablesForReviewer() {
                  // Get assignment and available reviewers
                  var disclosureReviewerId = getDisclosureReviewer();
                  var availableReviewersCollection = Radio.request(
                    'AppKit.resourceService',
                    'resource',
                    'availableReviewersCollection'
                  );

                  // Get reviewer ID and name from the available reviewer that is the assignee
                  var reviewer = availableReviewersCollection.findWhere({
                    userAccountId: disclosureReviewerId,
                  });
                  var reviewerName = reviewer ? reviewer.get('fullName') : '';

                  return [
                    {
                      name: 'reviewerId',
                      value: disclosureReviewerId,
                      type: 'string',
                    },
                    {
                      name: 'reviewerFullName',
                      value: reviewerName,
                      type: 'string',
                    },
                  ];
                }
              },



              onMethodSuccess: function(workflowTaskModel) {
                var model = this.view.model;
                if (model.get('actionDirection') === 'backward') {
                  this.view.trigger('disclosure:returned');
                } else {
                  var taskDefinitionKey = workflowTaskModel.get('taskDefinitionKey');
                  // Trigger "completed" behavior in order to route to the dashboard from either of these
                  if (taskDefinitionKey === 'resolveDisclosure' || taskDefinitionKey === 'disclosureConfirmReview') {
                    this.view.trigger('disclosure:completed');
                  }
                }
              },

              behaviorClass: BlocKit.InvokeModelMethodOnEventBehavior,
            },
            //Listen for complete/returned events and route user back to dashboard
            NavigateOnCompleteDisclosureBehavior: {
              eventName: 'disclosure:completed',
              routeName: 'default',
              behaviorClass: BlocKit.NavigateOnEventBehavior,
            },
            NavigateOnReturnDisclosureBehavior: {
              eventName: 'disclosure:returned',
              routeName: 'default',
              behaviorClass: BlocKit.NavigateOnEventBehavior,
            },
            BindAndFormatOptionValuesBehavior: {
              optionValues: {
                disabled: {
                  model: '@resources.workflowActivityStateModel',
                  modelAttribute: 'areAllActivitiesComplete',
                  formatter: function(areAllActivitiesComplete) {
                    var model = this.view.model;
                    return model.get('actionDirection') === 'forward' ? !areAllActivitiesComplete : false;
                  },
                },
                visible: {
                  formatter: function() {
                    const routingId = this.view.model.get('routingId');
                    const settingsModel = Radio.request('AppKit.resourceService','resource','settingsModel');
                    const userGroups = userPrincipalModel ? userPrincipalModel.get('groups') : [];
                    const isPassToReviewerButton = routingId === 'YES' || routingId === 'REVIEWER'; // 'YES' and 'REVIEWER' are the routingId's associated with the "Pass to reviewer" action buttons.
                    const isSysAdmin = userGroups.includes('COI System Administrator');

                    const shouldBeVisible = function() {
                      // always hide the "Pass To Reviewer" button. That functionality is handled elsewhere in the UI.
                      if(isPassToReviewerButton) {
                        return false;
                      // if it's the resolve button AND if only admins can resolve a COI, then the button should be visible only if the user is a sysAdmin
                      } else if (isResolveButton && settingsModel.get('isAdminOnly')) {
                          return isSysAdmin;
                      // everything else is visible
                      } else {
                        return true;
                      }
                    }

                    return shouldBeVisible();
                  },
                },
              },
              behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
            },
          };
        },
      },
    },
  };
});

